<template>
    <div >
        <form action="https://perfectmoney.com/api/step1.asp" id= "submit_payment" target='_blank' method="POST">
          <p>
            <input type="hidden" name="PAYEE_ACCOUNT" value="U48529821" />
            <input type="hidden" name="PAYEE_NAME" value="HIROPAY" />
            <input id="amount" type="hidden" name="PAYMENT_AMOUNT" value />
            <input type="hidden" name="PAYMENT_UNITS" value="USD" />
            <input id="status_url" type="hidden" name="STATUS_URL" value />
            <input id="payment_id" type="hidden" name="PAYMENT_ID" value />
            <input id="payment_url" type="hidden" name="PAYMENT_URL" value />
            <input id="nopayment_url" type="hidden" name="NOPAYMENT_URL" value />
            <input type="hidden" name="BAGGAGE_FIELDS" value="ORDER_NUM CUST_NUM" />
            <input id="order_num" type="hidden" name="ORDER_NUM" value />
            <input id="cust_id" type="hidden" name="CUST_NUM" value />
            <v-divider></v-divider>
            <v-flex xs12 text-xs-center>
              <v-btn color="success" :loading="loading" @click="setAmount" >PAYER</v-btn>
            </v-flex>
          </p>
        </form>
    </div>
</template>

<script>
import firebase from '../../fb'
import axios from 'axios'
import db from '../../db'
    export default {
        props: {
            amount: {
                type: String,
                default: ""
            },
            data:{
                type:Object
            }
        },
        data() {
            return {
                order_num: process.env.VUE_APP_SECRET,
                cust_id: "",
                open_payment:false,
                payment_id: "",
                loading:false
            }
        },

        computed: {
    nopayment_url() {
      return `${this.base_url}/external/no_payment_pm` 
    },
    status_url(){
      return `${this.base_url}/external/status_pm`
    },
    payment_url(){
      return `${this.base_url}/external/payment_pm`
    },

  },
        methods: {
            async setAmount() {
      let am = Number(this.amount);
      if (am > 0) {
        var user = firebase.auth().currentUser;
        this.cust_id = 'external';
        let await_ref =  db.collection('recent_transactions').doc()
        this.payment_id = await_ref.id
        let data_set ={
          id:await_ref.id,
          user_id:user.uid,
          status:'attente',
          created_at: firebase.firestore.FieldValue.serverTimestamp()
        }
        let obj = {...data_set,...this.data}
        console.log(obj);

        const set_alement = x => {
          let a = document.getElementById(x);
          a.setAttribute("value", this[x]);
        };

         let elements = ["amount","nopayment_url","status_url","payment_url","cust_id","payment_id","order_num"]
              elements.forEach(element => {
                set_alement(element);
              });
      
         let form = document.getElementById("submit_payment")
           console.log(form);
        let baseurl = `${this.base_url}/external`
        let request_headers = await this.get_headers(obj)
            if (location.hostname === "localhost") {
                  baseurl = 'http://localhost:4000/external'
                }
            let url = `${baseurl}/pay_pm`
            this.loading = true

            await axios.post(url,{},request_headers).then(result => {
              this.loading = false
              let {data} = result
              console.log('hii');
              console.log(data);
            if (data== 'success') {
              form.submit();
              this.$root.$emit("pay_pm_dialog")
              }else{
                swal({
                                  title: "Erreur",
                                  text: "erreur survenue veuillez reessayer",
                                  icon: "error",
                                })

              }
            })

      } else {
        console.log('montant inféfieur à 0');
      }
    },
        },
        
    }
</script>

<style lang="scss" scoped>

</style>